import { render } from "./PR54-06032026.vue?vue&type=template&id=0035ef08"
import script from "./PR54-06032026.vue?vue&type=script&lang=js"
export * from "./PR54-06032026.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__